import { ComponentProps } from 'react'

import { trackEvent } from '../../../../../lib/analytics'
import { useIsGiftCard } from '../hooks/useIsGiftCard'

import { GiftCardDetails } from './GiftCardDetails'
import { StandardProductDetails } from './StandardProductDetails'
import { Content, Layout } from './styles'

export type DetailsSectionProps = {
  product: ComponentProps<typeof GiftCardDetails>['product'] &
    ComponentProps<typeof StandardProductDetails>['product']
  variantGroup: ComponentProps<typeof GiftCardDetails>['variantGroup'] &
    ComponentProps<typeof StandardProductDetails>['variantGroup']
  variant: ComponentProps<typeof GiftCardDetails>['variant']
  deprecatedProps: ComponentProps<typeof StandardProductDetails>['deprecatedProps']
}

export const DetailsSection = ({
  product,
  variantGroup,
  variant,
  deprecatedProps,
}: DetailsSectionProps) => {
  const isGiftCard = useIsGiftCard({
    productGroupHandle: product.handle,
  })

  return (
    <Layout {...trackEvent({ category: 'product details', action: 'click product details' })}>
      <Content>
        {isGiftCard ? (
          <GiftCardDetails product={product} variantGroup={variantGroup} variant={variant} />
        ) : (
          <StandardProductDetails
            product={product}
            variantGroup={variantGroup}
            deprecatedProps={deprecatedProps}
          />
        )}
      </Content>
    </Layout>
  )
}
